/**
 * @file: ListModel.js
 * @author: liuye11(liuye11@baidu.com)
 */

import {toLower, assign} from 'lodash';
import {HEAT_MAP_SCRIPT} from './heatmap';
import {fillMissingDay} from '@/common/utils';
import ListModel from '../common/ReportListModel';

export default class Model extends ListModel {
    init() {
        super.init();
        this.listRequester = this.api.statsInteractCardList;
        this.trendRequester = this.api.statsInteractCardTrend;
        this.downloadApi = this.api.statsInteractCardListDownload;
        this.heatMapRequester = this.api.statsInteractCardHeatMap;
    }

    adaptData(data) {
        data.result.forEach(item => {
            item.statusLabel = this.cardStatusMap[item.status];
            item.statusColor = toLower(item.status);
            item.clickThroughRatioPercent = this.toPercentText(item.clickThroughRatio);
            item.interactClickRatioPercent = this.toPercentText(item.interactClickRatio);
        });
        return data;
    }

    requestHeatMapData(id) {
        return this.heatMapRequester(assign({id}, this.pickParamsWithDate()));
    }

    /**
     * 在物料HTML的基础上，插入热力图相关的js等内容，生成最后的HTML字符串
     *
     * @param {string} html 物料HTML字符串
     * @param {Object} data 需要传入的数据
     * @param {string} mcid mcid
     * @return {string}
     */
    genHeatMapMaterialHTML({html, data, mcid}) {
        return html.replace(
            /(<\/body><\/html>)$/,
            `
            <script>
                function ECMA_define(factory){window.__pack=factory()}
                var HEAT_MAP_MCID = '${mcid}';
                var HEAT_MAP_DATA = ${JSON.stringify(data)};
                var AD_CONFIG;
            </script>
            <script>${HEAT_MAP_SCRIPT}</script>
            $1
            `
        );
    }

    /**
     * @override
     */
    fillMissingDayData(data, {startDate, endDate}) {
        // 填充交互体验图表默认值
        return fillMissingDay(data, startDate, endDate, {
            clickThrough: 0,
            clickThroughRatio: 0,
            interactClick: 0,
            interactClickRatio: 0
        });
    }
}
